
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/moengage",
      function () {
        return require("private-next-pages/destinations/moengage.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/moengage"])
      });
    }
  